import React, { Component } from 'react';
import styles from './footer.module.less';

export default class Footer extends Component {
    render() {
        return <footer>
            <div className={styles.safe_tips}>Giao diện đã được xác minh bảo mật</div>
        </footer>
    }
}
